/** @format */

// store/modules/dirs.js

export default {
  namespaced: true,

  state: () => ({
    data: {},
    loading: {},
    loaded: {},
    used: {},
  }),

  getters: {
    get: (state) => (name) => state.data[name] || [],
    isUsed: (state) => (name) => !!state.used[name],
    isLoaded: (state) => (name) => !!state.loaded[name],
  },

  mutations: {
    SET_DIR(state, { name, items }) {
      state.data = {
        ...state.data,
        [name]: items,
      };
      console.log('SET_DIR', name);

      state.loading[name] = false;
      state.loaded[name] = true;
    },
    SET_LOADING(state, name) {
      //console.log('SET_LOADING', name);
      state.loading[name] = true;
    },

    MARK_USED(state, name) {
      //console.log('MARK_USED', name);
      state.used[name] = true;
    },

    RESET_DIR(state, name) {
      state.data[name] = [];
      state.loading[name] = false;
      state.loaded[name] = false;
    },
    initKey(state, key) {
      if (!state.data[key]) state.data[key] = [];
    },
    setDir(state, { key, items }) {
      state.data = { ...state.data, [key]: items };
    },
    UPDATE_ITEM(state, { name, item }) {
      const list = state.data[name] || [];

      const index = list.findIndex((i) => i.value === item.value);

      if (index !== -1) {
        list.splice(index, 1, item);
      } else {
        list.push(item);
      }

      state.data = { ...state.data, [name]: [...list] };
    },
  },

  actions: {
    async load({ state, commit, rootState }, { name, axios }) {
      if (state.loading[name]) return;
      if (state.loaded[name]) return;
      commit('SET_LOADING', name);

      const { loadDir } = await import('@/services/dirService');
      const data = await loadDir({
        name,
        axios,
        store: this,
      });

      commit('SET_DIR', { name, items: data });
    },

    async refresh({ dispatch, commit }, { name, axios }) {
      commit('RESET_DIR', name);
      await dispatch('load', { name, axios });
    },
    async updateById({ commit }, { name, id, axios }) {
      const { loadDirById } = await import('@/services/dirService');

      const item = await loadDirById({
        name,
        id,
        axios,
        store: this,
      });

      if (item) {
        commit('UPDATE_ITEM', { name, item });
      }
    },
  },
};
